<template>
  <div>
    <Hero />
    
    <section class="filters" id="categories">
      <div class="container">
        <div class="filter-buttons">
          <button 
            v-for="filter in filters" 
            :key="filter.id"
            :class="['filter-btn', { active: activeFilter === filter.id }]" 
            @click="filterArticles(filter.id)"
          >
            {{ filter.label }}
          </button>
        </div>
      </div>
    </section>
    
    <section class="articles-container" id="articles">
      <div class="container">
        <h2 class="section-title">Articles récents</h2>
        
        <div class="articles-grid">
          <ArticleCard 
            v-for="(article, index) in filteredArticles" 
            :key="article.id" 
            :article="article" 
            :index="index"
          />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Hero from '../components/Hero.vue'
import ArticleCard from '../components/ArticleCard.vue'
import { articles } from '../data/articles'

export default {
  name: 'HomeView',
  components: {
    Hero,
    ArticleCard
  },
  data() {
    return {
      articles: articles,
      activeFilter: 'all',
      filters: [
        { id: 'all', label: 'Tous les articles' },
        { id: 'dev', label: 'Développement' },
        { id: 'tech', label: 'Technologies' },
        { id: 'ai', label: 'IA & Data' },
        { id: 'web', label: 'Web & Mobile' },
        { id: 'arti', label: 'Intelligence Artificielle' },
        { id: 'career', label: 'Carrière & Emploi IT' }        
      ]
    }
  },
  computed: {
    filteredArticles() {
      if (this.activeFilter === 'all') {
        return this.articles
      }
      return this.articles.filter(article => article.category === this.activeFilter)
    }
  },
  methods: {
    filterArticles(category) {
      this.activeFilter = category
    }
  }
}
</script>

<style scoped>
.filters {
  padding: 40px 0 20px;
  background: white;
  margin-bottom: 30px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.filter-buttons {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 15px;
}

.filter-btn {
  padding: 10px 20px;
  background: var(--gray-light);
  border: none;
  border-radius: 50px;
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition);
  color: var(--dark);
}

.filter-btn:hover {
  background: var(--primary);
  color: white;
}

.filter-btn.active {
  background: var(--primary);
  color: white;
}

.articles-container {
  padding: 40px 0 80px;
}

.section-title {
  text-align: center;
  margin-bottom: 40px;
  font-size: 2.2rem;
  color: var(--dark);
  position: relative;
}

.section-title::after {
  content: '';
  display: block;
  width: 80px;
  height: 4px;
  background: var(--primary);
  margin: 10px auto;
  border-radius: 2px;
}

.articles-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 30px;
}

@media (max-width: 576px) {
  .filter-buttons {
    flex-direction: column;
    align-items: center;
  }
}
</style>